export default "__VITE_ASSET__C$gYlMQf__"